import { gql } from '@apollo/client';

export const CREATE_VIDEO = gql`
  mutation createVideo($data: CreateVideoInput!) {
    createVideo(data: $data) {
      message
    }
  }
`;

export const UPDATE_VIDEO = gql`
  mutation updateVideo($data: UpdateVideoInput!, $id: ID!) {
    updateVideo(data: $data, where: { id: $id }) {
      message
    }
  }
`;

export const BULK_EDIT_VIDEOS = gql`
  mutation bulkEditVideos(
    $where: BulkEditVideoWhereInput!
    $data: BulkEditVideoDataInput!
  ) {
    bulkEditVideos(where: $where, data: $data) {
      message
    }
  }
`;
